import InformationBlock from './InformationBlock';
import { InformationBlockProps, InformationBlockValueProps } from './types';

export type { InformationBlockProps, InformationBlockValueProps };
export default InformationBlock;
